export const snapTo = (value: number, step: number) => Math.round(value / step) * step

export const degreesToRadians = (degrees: number) => (degrees * Math.PI) / 180
